import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} spacing={3}>
          <FormSection>
            <FDInputRow>
              <MetaControlField attr={'incomeType'} flex={1} />
              <MetaControlField attr={'name'} flex={1} />
            </FDInputRow>
          </FormSection>
          <FormSection title={`${resource.selectedOptionPrompt('incomeType')} Information`}>
            <FDInputRow>
              <MetaControlField attr={'frequencyGrossValue'} flex={1} />
              <MetaControlField attr={'frequency'} flex={1} />
              <MetaControlField attr={'startDate'} flex={1} />
              <MetaControlField attr={'isTaxFree'} flex={1} />
            </FDInputRow>
            <MetaLayoutRemainingFields />
          </FormSection>
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          onClick={onSubmit}
          label="Submit"
        />
      </DialogActions>
    </>
  );
};

export default Layout;
